import { take, takeLatest } from "redux-saga/effects";
import { Action } from "../../App/ThemeManagement/actions";
import * as actions from "../../App/ThemeManagement/actions";
import * as sagas from "../../App/ThemeManagement/actions/sagas";

export function* watchAddNewLogo() {
  yield takeLatest(
    Action.ADD_NEW_LOGO,
    sagas.addNewLogo({
      onFailure: actions.handleAddNewLogoFailure,
      onSuccess: actions.handleAddNewLogoSuccess,
    })
  );
}

export function* watchPatchStyle() {
  yield takeLatest(
    Action.PATCH_STYLE,
    sagas.patchStyle({
      onFailure: actions.handlePatchStyleFailure,
      onSuccess: actions.handlePatchStyleSuccess,
    })
  );
}

export function* watchPatchOrganization() {
  yield takeLatest(
    Action.PATCH_ORG,
    sagas.patchOrganization({
      callback: () => actions.updateStyles(),
      onFailure: actions.handlePatchOrganizationFailure,
      onSuccess: actions.handlePatchOrganizationSuccess,
    })
  );
}

export function* watchApplyFontToSection() {
  yield takeLatest(
    Action.APPLY_FONT_TO_SECTION,
    sagas.applyFontToSection({
      onFailure: actions.handleApplyFontToSectionFailure,
      onSuccess: actions.handleApplyFontToSectionSuccess,
    })
  );
}

export function* watchLoadOrgFontFamilies() {
  yield takeLatest(
    Action.LOAD_ORG_FONT_FAMILIES,
    sagas.loadOrgFontFamilies({
      onFailure: actions.handleLoadOrgFontFamiliesFailure,
      onSuccess: actions.handleLoadOrgFontFamiliesSuccess,
    })
  );
}

export function* watchMount() {
  yield takeLatest(
    Action.MOUNT,
    sagas.firstFetch({
      onFailure: actions.handleFirstFetchFailure,
      onSuccess: actions.handleFirstFetchSuccess,
    })
  );
}

export function* watchUpdateStyles() {
  yield takeLatest(Action.UPDATE_STYLES, sagas.updateStyles());
}

export function* watchUnmount() {
  yield take(Action.UNMOUNT);
}
